import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Routes, Route } from 'react-router-dom';
import CustomViewer from '~/containers/CustomViewer';
import NewFullLayout from '~/components/Layout';
import LoadingScreen from '~/components/LoadingScreen';
import styles from './newstyles';
const Div = styled.div `
  ${styles}
`;
const Loading = () => (_jsx(Div, { children: _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(NewFullLayout, {}), children: _jsx(Route, { path: "", element: _jsx(LoadingScreen, {}) }) }) }) }));
const NewViewer = ({ openFormModal, nameOnly }) => (_jsx(Div, { newViewer: true, children: _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(NewFullLayout, {}), children: _jsx(Route, { path: "", element: _jsx(CustomViewer, { openFormModal: openFormModal, nameOnly: nameOnly }) }) }) }) }));
export { NewViewer, Loading, };
